import DefaultAvatarIcon from "@/assets/icons/person-avatar.svg?react";
import { cn } from "@/lib/utils";

type AvatarProps = {
  url?: string;
  className?: string;
  size: number;
};
export default function Avatar({ url, className, size }: AvatarProps) {
  return url ? (
    <img
      src={url}
      width={size}
      height={size}
      alt="avatar"
      style={{ minHeight: `${size}px` }}
      className={cn("shrink-0 rounded-full bg-p", className)}
    />
  ) : (
    <div
      style={{ width: `${size}px`, height: `${size}px` }}
      className={cn("flex shrink-0 items-center justify-center rounded-full bg-blue-200", className)}
    >
      <DefaultAvatarIcon className="stroke-blue-700" />
    </div>
  );
}
